import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {NavigatorBarModel} from "../_models/NavigatorBarModel";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";

export const IT_NAVIGATOR_BAR_CONTROLLER = new InjectionToken<INavigatorBarController>('IT_NAVIGATOR_BAR_CONTROLLER');
export const MK_NAVIGATOR_BAR = new ModelKey<NavigatorBarModel>('MK_NAVIGATOR_BAR');

export interface INavigatorBarController extends IController {

  handleInit(eventData: any): void;
  handleItemSelection(eventData: any): void;

  onNavigatorBarItems(event: ControllerEvent): void;
}
